import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ROUTES } from './constants';
import SearchPage from './pages/search/SearchPage';
import NotFound from './pages/NotFound';

const App: React.FC = () => (
  <Routes>
    <Route index element={<Navigate to={ROUTES.SEARCH} replace />} />
    <Route path={ROUTES.SEARCH} element={<SearchPage />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default App;
